import { AbstractControl, Validators, ValidatorFn } from "@angular/forms";
import { isPresent, isDate } from "../../helpers/function";

export const date: ValidatorFn = (
  control: AbstractControl
): { [key: string]: boolean } => {
  if (isPresent(Validators.required(control))) return null;

  const v: string = control.value;
  return isDate(v) ? null : { date: true };
};
